import { reactive, on } from 'minimal-view'

export type Screen = typeof Screen.State

export const Screen = reactive('screen',
  class props {
  },
  class local {
    pr = window.devicePixelRatio
    cursor = 'default'
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, refs, deps }) {
    fx(() =>
      on(window, 'resize')(() => {
        $.pr = window.devicePixelRatio
      })
    )

    fx(({ cursor }) => {
      document.body.style.cursor = cursor
    })
  }
)

export const screen = Screen({})
